<template>
    <div class="">
        <div class="contact-us full-screen">
            <div class="wrapper wrapper-full-page section content mb-4">
                <!-- <div class="text-left"></div> -->
                <div class="container">
                    <div class="text-left">
                        <img class="image-survey mb-2 mt-5" src="@/assets/img/election_logo.png" alt="MUIC">
                        <h2 class="font-thai mt-3 mb-1 font-weight-bold f-purple">Mahidol University International College</h2>
                        <hr class="mt-1 mb-1">
                        <div class="mb-2 text-dark" v-if="contentData.length != 0">
                            <b-alert show variant="warning-CUS">
                                <h4 class="text-dark font-thai mt-2 mb-1">TOPIC SURVEY : {{ contentData[0].topic }}</h4>
                                <h5 class="text-dark font-thai mb-2">{{ contentData[0].detail }}</h5>
                            </b-alert>
                        </div>
                        <!-- <pre>{{ contentData }}</pre> -->
                    </div>
                    <!-- <hr class="mt-1 mb-1"> -->
                    <!-- <h4 class="mt-2 mb-3 font-thai text-dark">IT Support Service</h4> -->
                    <div class="row">
                        <div class="col-sm-12 col-md-8 col-lg-8 col-xl-8">
                            <div v-for="(item, index) in dataQuestion" :key="'answer'+ index">
                                <!-- {{ item }} -->
                                <b-card v-if="item.question_type === 'radio'" class="ccc card-custom-survey">
                                    <template #header>
                                        <h5 class="mt-0 mb-0 f-2 font-thai">{{ item.question_ask }}<span class="text-danger ml-2" v-if="item.required">*</span></h5>
                                    </template>
                                    <b-card-text class="ml-3">
                                        <b-form-group class="mb-0 mt-0">
                                            <b-form-radio-group
                                                class="font-thai-choice text-dark font-weight-bold"
                                                size="sm"
                                                :id="`btn-radios-${item.id}`"
                                                :options="JSON.parse(item.choice)"
                                                :name="`n-btn-radios-${item.id}`"
                                                v-model="valueData[item.id]"
                                                stacked
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </b-card-text>
                                </b-card>
                                <b-card v-if="item.question_type === 'text'" class="ccc card-custom-survey">
                                    <template #header>
                                        <h5 class="mt-0 mb-0 f-2 font-thai">{{ item.question_ask }}<span class="text-danger ml-2" v-if="item.required">*</span></h5>
                                    </template>
                                    <b-card-text class="ml-3">
                                        <b-form-group class="mb-0 mt-0">
                                            <b-form-textarea
                                                :name="`textarea-${item.id}`"
                                                v-model="valueData[item.id]"
                                                placeholder="Enter something..."
                                                rows="3"
                                                max-rows="6"
                                                class="font-thai-input"
                                            ></b-form-textarea>
                                        </b-form-group>
                                    </b-card-text>
                                </b-card>
                                <b-card v-if="item.question_type === 'select' && item.choice_limit == 1" class="ccc card-custom-survey">
                                    <template #header>
                                        <h5 class="mt-0 mb-0 f-2 font-thai">{{ item.question_ask }}<span class="text-danger ml-2" v-if="item.required">*</span></h5>
                                    </template>
                                    <b-card-text class="ml-3">
                                        <b-form-group class="mb-0 mt-0">
                                            <b-form-select 
                                                :name="`select-${item.id}`"
                                                v-model="valueData[item.id]"
                                                :options="JSON.parse(item.choice)"
                                            ></b-form-select>
                                        </b-form-group>
                                    </b-card-text>
                                </b-card>
                                <b-card v-if="item.question_type === 'select' && item.choice_limit > 1" class="ccc card-custom-survey">
                                    <template #header>
                                        <h5 class="mt-0 mb-0 f-2 font-thai">{{ item.question_ask }}<span class="text-danger ml-2" v-if="item.required">*</span></h5>
                                    </template>
                                    <b-card-text class="ml-3">
                                        <b-form-checkbox-group
                                            @change="filterLimit($event,item.choice_limit,item.id)"
                                            :disabled="limit_reached" 
                                            :options="JSON.parse(item.choice)"
                                            :id="`checkbox-${item.id}`"
                                            :name="`checkbox-${item.id}`"
                                            v-model="valueData[item.id]"
                                        ></b-form-checkbox-group>
                                    </b-card-text>
                                </b-card>
                                <b-card v-if="item.question_type === 'short_text'" class="ccc card-custom-survey">
                                    <template #header>
                                        <h5 class="mt-0 mb-0 f-2 font-thai">{{ item.question_ask }}<span class="text-danger ml-2" v-if="item.required">*</span></h5>
                                    </template>
                                    <b-card-text class="ml-3">
                                        <b-form-group class="mb-0 mt-0">
                                            <b-form-input
                                                class="font-thai-input" 
                                                :name="`input-${item.id}`"
                                                v-model="valueData[item.id]"
                                                placeholder="Enter something...">
                                            </b-form-input>
                                        </b-form-group>
                                    </b-card-text>
                                </b-card>
                            </div>
                        </div>
                    </div>
                    <!-- <pre>{{ valueData }}</pre> -->
                    <div>
                        <b-button :disabled="isFormValue" @click="showModal" variant="success" class="f-3 font-thai mr-2"><i class="fa fa-paper-plane-o mr-1" aria-hidden="true" /> Submit</b-button>
                        <b-button variant="danger" class="f-3 font-thai"><i class="fa fa-times mr-1" aria-hidden="true" /> Clear</b-button>
                    </div>
                    <br><br><br>
                </div>
            </div>
        </div>
        <!-- modal confi -->
        <b-modal class="text-center" ref="my-modal" hide-footer>
            <template #modal-title>
                <div class="text-center">
                    <h4 class="font-thai mb-0 mt-0">Confirm !</h4>
                </div>
            </template>
            <div class="text-center">
                <!-- loadSubmit -->
                <span v-if="loadSubmit">
                    <b-button class="f-3 font-thai mr-2" variant="success" disabled>
                        <b-spinner small class="mr-2"></b-spinner>proceed to submit your answer....
                    </b-button>
                </span>
                <span v-else>
                    <b-button @click="SubmitData" variant="success" class="f-3 font-thai mr-2"><i class="fa fa-paper-plane-o mr-1" aria-hidden="true" /> Confirm Submit</b-button>
                    <b-button @click="hideModal" variant="danger" class="f-3 font-thai"><i class="fa fa-times mr-1" aria-hidden="true" /> Close</b-button>
                </span>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                msgError:null,
                msgErrorContent:null,
                limit_reached:false,
                valueData: [],
                choiceVote:[],
                dataQuestion:[],
                contentData:[],
                arrRquied:[],
                loadSubmit:false,
            }
        },
        computed: {
            getTokenUrl(){
                return typeof(this.$route.query.token) === "undefined" || this.$route.query.token === "" ?  this.$router.push("/").catch(err => {}) : this.$route.query.token
            },
            isFormValue(){
                if(this.valueData.length === 0){
                    return true
                }else{
                    // console.log(this.arrRquied)
                    return false
                }
            }
        },
        mounted(){
            this.callContent()
            this.callTokenDetail()
        },
        methods: {
            filterLimit(event,limtcheck,indexC){
                // console.log(limtcheck)
                // console.log(indexC)
                // console.log(event.length)
                if(event.length >= limtcheck){
                    this.limit_reached = true
                }else{
                    this.limit_reached = false
                }
            },
            showModal(){
                this.$refs['my-modal'].show()
            },
            hideModal(){
                this.$refs['my-modal'].hide()
            },
            async callContent(){
                this.contentData = []
                this.msgErrorContent = null
                try {
                    const resContent = await this.$http.get(`/survey/form/?token=${this.getTokenUrl}`)
                    if(resContent.status === 200){
                        this.contentData.push(resContent.data)
                    }
                } catch (error) {
                    this.msgErrorContent = null
                }
            },
            async callTokenDetail(){
                this.msgError = null
                this.choiceVote = []
                this.dataQuestion = []
                this.arrRquied = []
                try {
                    const res = await this.$http.get(`/survey/question/?token=${this.getTokenUrl}`)
                    if(res.status === 200){
                        // console.log(res.data)
                        // 
                        this.arrRquied = res.data.filter( itemFilter => {
                            return itemFilter.required === true
                        }).map(itemRequied => {
                            return itemRequied.id
                        })
                        // 
                        this.dataQuestion = res.data.map(item => {
                            return {
                                'id':item.id,
                                'choice': item.choice,
                                'created_at': item.created_at,
                                'question_ask': item.question_ask, 
                                'question_order': item.question_order,
                                'question_type': item.question_type,
                                'required': item.required,
                                'survey_form': item.survey_form,
                                'choice_limit': item.choice_limit,
                            }
                        })
                    }else{
                        throw { res }
                    }
                } catch (error) {
                    this.msgError = 'Caught ! : respone data information'
                }
            },
            async SubmitData(){
                this.loadSubmit = true
                this.msgError = null
                // console.log(this.valueData)
                for (const [key, value] of Object.entries(this.valueData)) {
                    // console.log(`${key} : ${value}`);
                    try {
                        const sendAnswer = new FormData()
                        sendAnswer.append('q_ask', key)
                        sendAnswer.append('q_answer', value)
                        const resAnswer = await this.$http.post(`/survey/answer/?token=${this.getTokenUrl}`, sendAnswer,{
                            headers: { 'Content-Type': 'multipart/form-data' }
                        })
                        if(resAnswer.status === 200){}else{
                            throw { resAnswer }
                        }
                    } catch (error) {
                        this.msgError = 'Caught ! : respone send answer'
                    }
                }
                this.loadSubmit = false
                location.reload();
            }
        }
    }
</script>

<style>
    .f-label-c {
        color: #000000;
    }
</style>

<style lang="scss" scoped>
    @import url('https://fonts.googleapis.com/css2?family=Kanit:wght@500&family=Sarabun:wght@500&display=swap');
    @import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@500&display=swap');
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .card-custom-survey{
        border-radius: 3px;
        border-bottom: 1px solid #fff;
    }
    .font-thai{ 
        // font-family: 'Kanit', sans-serif; font-weight: 100; 
        font-family: 'Barlow Condensed', sans-serif;
    }
    .font-thai-choice{ 
        font-family: 'Kanit', sans-serif; font-weight: 100;
        color: #000;
        font-size: 24px;
        // font-family: 'Barlow Condensed', sans-serif;
    }
    .font-thai-input{ font-family: 'Kanit', sans-serif; font-weight: 100; }
    .f-2{ font-size: 1.25rem; }
    .f-3{ font-size: 18px; }
    .image-survey{
        width: 200px;
    }
    .f-purple{
        color: #492582;
    }
    .ccc{
        border-left:5px solid #492582;
    }
    .alert-warning-CUS {
        background-color: #fdf5de;
        color: #BB992F;
    }
    .bg-image {
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url("../../assets/img/bg-election.png");
    }
</style>